import { useQuery } from "@apollo/client";
import useFilters from "../core/hooks/useFilters";
import { LIST_QUOTATION } from "../apollo/queries";
import { getSelectedStoreDetails } from "../utils/helperFunctions";

const useQuotation = () => {
  const { search, debouncedValue, onChange, pagination, handlePageChange } =
    useFilters();
  const { loading, error, data, refetch } = useQuery(LIST_QUOTATION, {
    variables: {
      input: {
        limit: pagination.limit,
        pageStart: pagination.pageStart,
        store_id: getSelectedStoreDetails("id"),
        name: debouncedValue,
      },
    },
    fetchPolicy: "network-only",
  });

  if (error) {
    console.log("Error While Getting Brands", error);
  }

  return {
    values: {
      allOrder: data?.allOrder || [],
      total: data?.allOrder?.total || 0,
      loading,
      search,
      pageValues: {
        current: pagination.pageStart + 1,
        pageSize: pagination.limit,
        total: data?.allOrder?.total || 0,
      },
    },
    functions: {
      onChange,
      refetch,
      handlePageChange,
    },
  };
};

export default useQuotation;
